import { ExclamationTriangle } from 'src/shared/design-system/Icon';
import styled from 'styled-components';
import { Colors, Font, Spacing } from 'web-common/src/shared/styles';

const StyledSpan = styled.span`
  display: flex;
  align-items: center;
  font-family: ${Font.Family.SANS};
  font-weight: ${Font.Weight.SEMI_BOLD};
  font-size: ${Font.Size.XXS};
  color: ${Colors.RADISH_DARK_10};
`;

const Icon = styled(ExclamationTriangle)`
  color: ${Colors.RADISH_DARK_10};
  height: 14px;
  display: inline-flex;
  margin-right: ${Spacing.QUARTER};
`;

/**
 * @deprecated The shef-web design system is being retired. Use `components/Input`
 *   from `web-common/src/shared/design-system` instead.
 * @see https://app.asana.com/0/0/1218340209270973
 */
export const FormErrorMessage = ({ children, ...otherProps }) => (
  <StyledSpan {...otherProps}>
    <Icon />
    {children}
  </StyledSpan>
);
